module.exports = __webpack_public_path__ + "static/media/TowerVoltage.89f95cd3.jpg";